import React, { useState } from "react";
import Button from "devextreme-react/button";
import ScrollView from "devextreme-react/scroll-view";
import "../../../styles/scss/module-menu.scss";
import { useNavigate } from "react-router-dom";
import ThemeSwitch from "../themeSwitch/ThemeSwitch";

const ModuleMenu = (props) => {
  const components = props.componentsData;
  const [navOption, setNavOption] = useState(0);
  const [isClicked, setIsClicked] = useState(false);

  const navigate = useNavigate();

  const handleNavigation = (id) => {
    setNavOption(id);
  };

  // NavigationList component
  const NavigationList = () => {
    return (
      <div className="navbar">
        {components &&
          components.map((ele) => (
            <Button
              key={ele.id}
              text={ele.text}
              onClick={() => {
                handleNavigation(ele.id);
                setIsClicked(false);
              }}
              style={{
                backgroundColor: navOption === ele.id && "gray",
                border: "none",
                minWidth: "100px",
              }}
            />
          ))}
        {!window.location.href.includes("settings") ? (
          <Button
            key={123}
            text={"Default Layout"}
            onClick={() => {
              navigate("/tiers/layout");
              setIsClicked(true);
            }}
            style={{
              backgroundColor: isClicked && "gray",
              border: "none",
              minWidth: "100px",
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  // GridContent component
  const ComponentContent = () => {
    return <div className="component">{components[navOption].component}</div>;
  };

  const scrollConfig = {
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  };

  return (
    <>
      <div className="module-menu-wrapper">
        <div className="section-nav">
          <ScrollView {...scrollConfig} className="scroll">
            <div style={{ width: "100%" }}>
              <NavigationList />
            </div>
          </ScrollView>
          {window.location.href.includes("adminconsole") ? <ThemeSwitch /> : ""}
        </div>
        <div className="section-component">
          <ScrollView {...scrollConfig} className="scroll">
            <div style={{ width: "97%" }}>
              <ComponentContent />
            </div>
          </ScrollView>
        </div>
      </div>
    </>
  );
};

export default ModuleMenu;
